import React from 'react';

import ShowInPrint from '../elements/text/ShowInPrint';
import useToggle from '../hooks/useToggle';

import HeaderNavigation from './Header/HeaderNavigationV2';
import UserInformation from './Header/UserInformation';
import UserMenu from './UserMenuV2';
const printLogo = process.env.REACT_APP_STATIC_IMG_URL + '/logo/creditinfo-print-logo.png';
const ciLogo = process.env.REACT_APP_STATIC_IMG_URL + '/logo/creditinfo-logo-black-text.png';

export default ({
  mainText = '',
  subText = '',
  products = [],
  showMobileNav = true,
  toggleSidebar,
  userMenu = null,
  userMenuItems = [],
  toggleUserMenu = null,
  children
}) => {
  const hasUserMenu = userMenu !== null || userMenuItems.length > 0;
  const [isOpen, toggleOpen] = useToggle(false);

  if (hasUserMenu && userMenu === null) {
    userMenu = <UserMenu items={userMenuItems} open={isOpen} toggleOpen={toggleOpen} />;
  }

  return (
    <header id="main-header" className="main-header">
      <div className="grid" style={{ height: '100%' }}>
        <div className="col s4of6 logo-print-margin" style={{ height: '100%' }}>
          {showMobileNav && (
            <span
              className="mobilenav-toggle button icon-grid no-text white"
              onClick={toggleSidebar}
            />
          )}
          <a href="/">
            <img
              className="logo"
              src={ciLogo}
              alt="Creditinfo"
              style={{ ...(!showMobileNav && { left: 10 }) }}
            />
          </a>
          <ShowInPrint>
            <img src={printLogo} alt="Creditinfo" />
          </ShowInPrint>
          <HeaderNavigation products={products} />
        </div>
        <div
          className="col s2of6 no-print"
          style={{
            height: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            paddingRight: 30
          }}
        >
          <UserInformation
            name={mainText}
            sub={subText}
            onMenuClick={hasUserMenu ? toggleUserMenu || toggleOpen : null}
            navButtons={children}
          />
        </div>
      </div>
      {userMenu}
    </header>
  );
};
